var map = {
	"./products_beverage_red.png": 962,
	"./products_binde_red.png": 6859,
	"./products_bread_red.png": 5803,
	"./products_can_red.png": 7311,
	"./products_capsule_red.png": 8140,
	"./products_cardboardbox_red.png": 9528,
	"./products_carrierbag_red.png": 8987,
	"./products_cat_red.png": 4677,
	"./products_chips_red.png": 1648,
	"./products_christmas_red.png": 7353,
	"./products_claypot_red.png": 6989,
	"./products_coffecapsule_red.png": 6513,
	"./products_coffee_red.png": 1285,
	"./products_couvert_red.png": 6455,
	"./products_cuttlery_red.png": 4291,
	"./products_deathpet_red.png": 6400,
	"./products_deo_red.png": 3693,
	"./products_detergent_red.png": 8297,
	"./products_dishes_red.png": 8113,
	"./products_egg_red.png": 5018,
	"./products_gardeningtrash_red.png": 3584,
	"./products_grill_red.png": 4593,
	"./products_joghurt_red.png": 7066,
	"./products_katzenstreu_red.png": 4139,
	"./products_leftovers_red.png": 5865,
	"./products_meat_red.png": 2900,
	"./products_meatcut_red.png": 8434,
	"./products_medis_red.png": 6107,
	"./products_milkbottle_red.png": 2196,
	"./products_newspaper_red.png": 3888,
	"./products_oil_red.png": 993,
	"./products_pet_red.png": 8606,
	"./products_pizza_red.png": 4699,
	"./products_plasticbag_red.png": 6615,
	"./products_plasticcutlery_red.png": 8887,
	"./products_shampoo_red.png": 8778,
	"./products_teabag_red.png": 3457,
	"./products_tetra_red.png": 4533,
	"./products_trinkglas_red.png": 2306,
	"./products_vegis_red.png": 4315,
	"./products_wine_red.png": 4434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3635;